module.exports = __webpack_public_path__ + "static/media/LogoGoService.8a94116e.png";